window.confirmSubmit = (formId)  => {
    if (window.confirm("Do you really want to delete?")) {
        document.getElementById(formId).submit();
    }
}
